/* eslint-disable react/forbid-dom-props */
import React from 'react'

export const PrivacyIcon = () => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" width="32" height="32">
    <defs>
      <path
        id="privacy_a"
        d="M17.421 4.491c0 7.765-4.77 12.093-7.773 13.344a1.683 1.683 0 01-1.296 0C4.596 16.271.58 11.455.58 4.491c0-.68.409-1.293 1.036-1.554L8.352.13a1.683 1.683 0 011.296 0l6.737 2.807a1.683 1.683 0 011.036 1.554zM9 15.661h.002c3.29-1.638 6.053-5.484 6.17-10.797L9 2.292V15.66z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h32v32H0z" />
      <g transform="translate(7 7)">
        <mask id="privacy_b" fill="#fff">
          <use xlinkHref="#privacy_a" />
        </mask>
        <g fill="#9A8B88" fillRule="nonzero" mask="url(#privacy_b)">
          <path d="M-1.8-1.8h21.6v21.6H-1.8z" />
        </g>
      </g>
    </g>
  </svg>
)
